import { useMemo, useState } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { CarRentalFormDataWithTranslations } from '@/i18n/translation-type-utils';
import PricingSummaryCalendar from '../benefits/PricingSummaryCalendar';

interface CarRentalPricingSummaryProps {
  control: Control<CarRentalFormDataWithTranslations>;
}

const CarRentalPricingSummary = ({ control }: CarRentalPricingSummaryProps) => {
  const carCategories = useWatch({ control, name: 'carCategories' });

  const getCategoryName = (
    category: (typeof carCategories)[number],
    index: number,
  ) => {
    return category.category && category.model
      ? `${category.category}- ${category.model}`
      : `Véhicule ${index + 1}`;
  };

  const carCategoriesOptions = carCategories.map((category, index) => ({
    value: { name: getCategoryName(category, index), index },
    label: getCategoryName(category, index),
  }));

  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const currentTarifs = useMemo(
    () => carCategories[currentCategoryIndex]?.tarifs ?? [],
    [currentCategoryIndex, carCategories],
  );

  return (
    <PricingSummaryCalendar
      tarifs={currentTarifs}
      categoryOptions={carCategoriesOptions}
      currentCategoryIndex={currentCategoryIndex}
      onCategoryChange={setCurrentCategoryIndex}
    />
  );
};

export default CarRentalPricingSummary;
